<template>
<component :is="tag" data-module="CmsColumnList">
  <slot :list="list" v-if="!loading"></slot>
</component>
</template>

<script>
import {getColumns} from "~/api/CmsApi";


export default {
  name: 'CmsColumnList',
  props: {
    /**
     * 栏目父ID
     */
    pid: {
      type: [String, Number],
      // 默认获取中文版栏目下子栏目
      default: ''
    },
    /**
     * 分页查询起始页
     */
    page: {
      type: Number,
      default: 1
    },
    /**
     * 分页大小
     */
    limit: {
      type: Number,
      default: 999
    },
    /**
     * 指定元素渲染出的标签
     */
    tag: {
      type: String,
      default: 'div'
    },
    sortBy: {
      type: String,
      default: 'sort'
    },
    parseFunction: {
      type: Function,
      default: obj => {
        return obj;
      }
    }
  },
  data() {
    return {
      loading: true,
      list: []
    };
  },
  watch: {
    pid: {
      handler(value) {
        if (value) {
          this.initialize();
        }
      },
      immediate: true
    }
  },
  methods: {
    /**
     * 初始化数据
     */
    initialize() {
      const param = { page: this.page, limit: this.limit, pid: this.pid};
      getColumns(param).then(res => {
        if (res.code === 0) {
          const list = res.data.records || [];
          if (this.sortBy === 'sort') {
            list.sort((a, b) => a.sort - b.sort);
          }
          this.list = list.map(item => {
            return this.parseFunction(item);
          })
          this.$emit('loaded', list);
        } else {
          console.warn('栏目信息获取失败');
        }
        this.loading = false;
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cms/CmsColumnList.vue